import React, { PureComponent } from 'react'
import { get, put } from './util'
import Panel from './components/Panel'
import Button from './components/Button'

class Config extends PureComponent {
  state = {
    loading: true,
    unifiedProfile: false,
    externalProfile: false,
    profile: '',
    profileURL: '',
    profileUpdateInterval: 86400,
    saving: false
  }

  componentDidMount () {
    get('admin/info')
      .then(({ unifiedProfile, profile, externalProfile, profileURL, profileUpdateInterval }) => {
        this.setState({
          unifiedProfile,
          profile,
          externalProfile,
          profileURL,
          profileUpdateInterval,
          loading: false
        })
      })
      .catch(e => console.error(e))
  }

  handleSave = () => {
    this.setState({ saving: true })
    put('admin/info', {
      unifiedProfile: this.state.unifiedProfile,
      profile: this.state.profile,
      externalProfile: this.state.externalProfile,
      profileURL: this.state.profileURL,
      profileUpdateInterval: this.state.profileUpdateInterval
    })
      .then(() => {
        this.setState({ saving: false })
        alert('Saved successfully')
      })
      .catch(e => {
        alert(e.message ? `Failed to save: ${e.message}` : 'Failed to save')
        this.setState({ saving: false })
      })
  }

  render () {
    if (this.state.loading) {
      return <div className='flex items-center justify-center py-20 text-slate-500'>Loading config…</div>
    }

    return (
      <div className='space-y-4'>
        <Panel>
          <h2 className='text-xl font-semibold text-ink mb-4'>Unified Profile</h2>
          <label className='inline-flex items-center gap-2 text-sm text-slate-700'>
            <input
              type='checkbox'
              className='w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500'
              checked={this.state.unifiedProfile}
              onChange={e => this.setState({ unifiedProfile: e.target.checked })}
            />
            Enable unified profile for all users
          </label>
          {this.state.unifiedProfile && (
            <div className='mt-5 space-y-4'>
              <div className='flex gap-4 text-sm font-semibold'>
                <button
                  className={`pb-1 border-b-2 ${!this.state.externalProfile ? 'border-ink text-ink' : 'border-transparent text-slate-400'}`}
                  onClick={() => this.setState({ externalProfile: false })}
                >
                  Inline Text
                </button>
                <button
                  className={`pb-1 border-b-2 ${this.state.externalProfile ? 'border-ink text-ink' : 'border-transparent text-slate-400'}`}
                  onClick={() => this.setState({ externalProfile: true })}
                >
                  Hosted URL
                </button>
              </div>
              {this.state.externalProfile ? (
                <div>
                  <label className='text-sm font-medium text-slate-600'>Profile URL</label>
                  <input
                    className='mt-2 w-full rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
                    value={this.state.profileURL || ''}
                    onChange={e => this.setState({ profileURL: e.target.value })}
                    placeholder='https://'
                  />
                  <p className='text-xs text-slate-500 mt-1'>Use {'{username}'} and {'{passcode}'} placeholders to inject credentials.</p>
                </div>
              ) : (
                <div>
                  <label className='text-sm font-medium text-slate-600'>Profile Content</label>
                  <textarea
                    rows='10'
                    className='mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 font-mono text-sm focus:border-ink focus:ring-1 focus:ring-ink'
                    value={this.state.profile || ''}
                    onChange={e => this.setState({ profile: e.target.value })}
                  />
                </div>
              )}
            </div>
          )}
        </Panel>

        {this.state.unifiedProfile && (
          <Panel>
            <label className='block text-sm font-medium text-slate-600'>Update Interval (seconds)</label>
            <input
              type='number'
              className='mt-2 w-40 rounded-2xl border border-slate-200 px-4 py-2.5 focus:border-ink focus:ring-1 focus:ring-ink'
              value={this.state.profileUpdateInterval || ''}
              onChange={e =>
                this.setState({ profileUpdateInterval: Number(e.target.value) || 0 })
              }
            />
          </Panel>
        )}

        <div className='text-right'>
          <Button onClick={this.handleSave} disabled={this.state.saving}>
            {this.state.saving ? 'Saving…' : 'Save'}
          </Button>
        </div>
      </div>
    )
  }
}

export default Config
